import moment from 'moment';

// Перевод между датами и пикселями ленты. Своё, а не из состояния библиотеки: она кладёт
// в _scaleDate результат функции, которая переводит пиксели в часы независимо от единицы
// длины, и на сутках промахивается

const unitOf = (scales) => scales.lengthUnit || 'day';

const dateToPx = (api, date) => {
  const { _start, _scales } = api.getState();
  if (!_scales) return null;

  // дробный diff: для подводки ленты нужна точность мельче единицы длины
  return moment(date).diff(moment(_start), unitOf(_scales), true) * _scales.lengthUnitWidth;
};

export const pxToDate = (api, px) => {
  const { _start, _scales } = api.getState();
  if (!_scales) return null;

  return moment(_start)
    .add(Math.round(px / _scales.lengthUnitWidth), unitOf(_scales))
    .toDate();
};

// Подводит ленту так, чтобы дата оказалась в первой трети видимой области
export const centerOnDate = (api, date) => {
  const px = dateToPx(api, date);
  const { _chartWidth } = api.getState();

  if (px != null && _chartWidth) api.exec('scroll-chart', { left: px - _chartWidth / 3 });
};
